import { Selector, createSelector } from "@ngxs/store";
import { TaskStatusState, TaskStatusStateModel } from "./task-status.state";
import { TaskStatus } from "../../models/task-status.model";

export class TaskStatusSelectors {

  @Selector([TaskStatusState])
  static getTaskStatuss(state: TaskStatusStateModel): TaskStatus[] {
    return state.taskStatus;
  }

  @Selector()
  static getStatusNameById(statusId: number) {
    return createSelector([TaskStatusState], (state) => {
      const status = state.taskStatus.taskStatus.find(l => l.id == statusId)
        return status;
    });
  }
}
